import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';
export default class AuthService {
    logout() {
        localStorage.clear();
        window.location.replace('/login');
    }

    login(username, password) {
        let formData = { username, password };
        return HttpService.post(environment.API_LOGIN, formData);
    }

    changePassword(payload) {
        return HttpServiceNoToken.post(
            environment.API_CHANGE_PASSWORD,
            payload
        );
    }

    forgotPassword(email) {
        return HttpServiceNoToken.post(environment.API_FORGOT_PASSWORD, email);
    }

    checkToken(value) {
        return HttpServiceNoToken.get(environment.API_CHECK_TOKEN + value);
    }

    newPassword(newPassword, confirmPassword, linkToken) {
        let formData = { newPassword, confirmPassword, linkToken };
        return HttpServiceNoToken.post(environment.API_NEW_PASSWORD, formData);
    }

    getUser() {
        return HttpService.get(environment.API_PROFILE);
    }
}
